import { render } from "./PlaceholdersPage.vue?vue&type=template&id=6172635a&ts=true"
import script from "./PlaceholdersPage.vue?vue&type=script&lang=ts"
export * from "./PlaceholdersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__